
import Main from '../components/Main.vue'
import GK from '../components/GKZL.vue'
import ZK from '../components/ZKJC.vue'
import BookDetail from '../components/BookDetail.vue'
import CJZSDetail from '../components/CJZSDetail.vue'
import About from '../components/About.vue'
import SFJC from '../components/SFJC.vue'
import BKZZ from '../components/BKZZ.vue'
import TJTS from '../components/TJTS.vue'
import CJZS from '../components/CJZS.vue'
import Others from '../components/Others.vue'
import NewList from '../components/NewList.vue'
import NewDetail from '../components/NewDetail.vue'
import BookMore from '../components/BookMore.vue'
import HotMore from '../components/HotMore.vue'
import BookCode from '@/components/BookCode.vue'
import {createRouter, createWebHistory} from "vue-router"


const routes = [
    {
        path: '/',
        component: Main
    },
    {
        path: '/gkzl',
        component: GK
    },
    {
        path: '/zkjc',
        component: ZK
    },
    {
        path: '/sfjc',
        component: SFJC
    },
    {
        path: '/bookdetail/:id',
        component: BookDetail,
        props: true
    },
    {
        path: '/cjzsdetail/:id',
        component: CJZSDetail,
        props: true
    },
    {
        path: '/bookcode/:id',
        component: BookCode,
        props: true
    },
    {
        path: '/about',
        component: About
    },
    {
        path: '/bkzz',
        component: BKZZ
    },
    {
        path: '/tjts',
        component: TJTS
    },
    {
        path: '/cjzs',
        component: CJZS
    },
    {
        path: '/others',
        component: Others
    },
    {
        path: '/newlist/:classify',
        component: NewList,
        props: true
    },
    {
        path: '/newdetail/:id/:classify/:page',
        component: NewDetail,
        props: true
    },
    {
        path: '/bookmore/:ishot/:classify',
        component: BookMore,
        props: true
    },
    {
        path: '/hotmore/:ishot/:classify',
        component: HotMore,
        props: true
    }
]


const router = createRouter({
    history: createWebHistory(),
    routes
})


export  default router;
